import React from 'react';
import {Global} from './Global';

const pageContext = React.createContext({
    currentPage: Global.homePage,
    handlePageClick: (login: String) => {}
});

export default pageContext;